module.exports = __webpack_public_path__ + "static/media/eten_in_spanje.6fbd4af4.jpg";